import TemplateView from "../../../../TemplateView"
import {HierarchyLevels} from "constants"
import EmptyHighlighter from "../../../../util/EmptyHighlighter"
import messageResource from '../../../../messageResource'
import {getInstance as assignmentsTooltip} from '../../../../SimpleSingletonTooltip'


export default class TextNode extends TemplateView {
    constructor({
        id = -1,
        type = HierarchyLevels.TASK,
        additionalClass = "",
        needRevokeButton = false,
    }) {
        super();

        this.params = {
            id,
            type,
            additionalClass,
            needRevokeButton,
        }

        this.state = {
            highlightedTitle: "",
            tokensHighlighter: new EmptyHighlighter(),
            additionalTitle: "",
            note: "",
            revokeEnabled: false,
            revokeCallback: (id) => {},
            maExcludeSelf: false,
        }

        this.onStateChanged(() => {
            this.find(".title").html(this.state.highlightedTitle)
            this.find(".additionalTitle").text(this.state.additionalTitle)
            this.find(".note").text(this.state.note)

            this.unsubscribeTooltip && this.unsubscribeTooltip()
            if (this.state.revokeEnabled) {
                this.$revokeButton.click(() => this.state.revokeCallback(this.params.id));
            } else {
                this.$revokeButton.addClass("disabled");
                let levelName = ""
                let childLevelsName = ""
                switch (this.params.type) {
                    case HierarchyLevels.CUSTOMER:
                        levelName = messageResource.getMessage('common.customer')
                        childLevelsName = messageResource.getMessage('common.projects')
                        break
                    case HierarchyLevels.PROJECT:
                        levelName = messageResource.getMessage('common.project')
                        childLevelsName = messageResource.getMessage('common.tasks')
                        break
                    default:
                        levelName = messageResource.getMessage('common.task')
                        break
                }
                let tooltipText = ""
                if (this.state.maExcludeSelf) {
                    tooltipText = messageResource.getMessage('assigned_users_editor.disabled_tooltip.user_manage_all_existing_and_future', [levelName, childLevelsName])
                } else {
                    tooltipText = messageResource.getMessage('assigned_users_editor.work.disabled_tooltip.user_manages_item', [levelName])
                }

                this.unsubscribeTooltip = assignmentsTooltip().subscribeToMouseEvents(this.$revokeButton, () => {
                    assignmentsTooltip().setState({
                        text: tooltipText,
                        extraClass: 'hierarchyAssignmentsTooltip',
                    })
                })
            }

            this.$revokeButton.toggle(needRevokeButton && !!this.state.revokeCallback)
        })
    }

    templateHtml() {
        return "<div class='<%-additionalClass%>'>" +
               "    <div class='entitiesName'>" +
               "        <div class='title'></div>" +
               "        <div class='additionalTitle'></div>" +
               "    </div>" +
               "    <div class='noteAndRevokeButtonContainer'>" +
               "        <div class='note'></div>" +
               "        <div class='revokeButton'></div>" +
               "    </div>" +
               "</div>";
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    afterRender() {
        this.$revokeButton = this.find(".revokeButton")
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/components/TextNode.js